import React from 'react';
import { useDispatch } from 'react-redux';
import { undo, redo } from '../../../../redux/stepsSlice';

// Walkthrough Editor v2 — canvas toolbar (BL-140).
// Floating bar above the stage: Add Interactive Element (opens the element
// library modal, BL-141), Replace screenshot (BL-142), undo/redo (wired),
// and zoom (drives the shell's zoom state).

const PlusIcon = ({ bold }) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={bold ? 2.6 : 2} strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
);
const MinusIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg>
);
const PhotoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>
);
const UndoIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 14L4 9l5-5" /><path d="M4 9h11a5 5 0 0 1 0 10h-1" /></svg>
);
const RedoIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 14l5-5-5-5" /><path d="M20 9H9a5 5 0 0 0 0 10h1" /></svg>
);
const PanelRightIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2" /><line x1="15" y1="4" x2="15" y2="20" /></svg>
);
const PanelBottomIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="18" rx="2" /><line x1="4" y1="15" x2="20" y2="15" /></svg>
);

const WalkthroughCanvasToolbar = ({ zoom, onZoomIn, onZoomOut, onZoomReset, onAddElement, onReplaceScreenshot, filmOpen, inspOpen, onToggleFilm, onToggleInsp }) => {
  const dispatch = useDispatch();
  return (
    <div className="un-we-wtoolbar">
      <button type="button" className="un-we-wtoolbar__add" onClick={onAddElement}>
        <PlusIcon bold /> Add Interactive Element
      </button>
      <span className="un-we-wtoolbar__sep" />
      <button type="button" className="un-we-wtoolbar__btn" onClick={onReplaceScreenshot} title="Replace screenshot">
        <PhotoIcon /> Replace screenshot
      </button>
      <span className="un-we-wtoolbar__sep" />
      <button type="button" className="un-we-wtoolbar__ic" title="Undo" aria-label="Undo" onClick={() => dispatch(undo())}><UndoIcon /></button>
      <button type="button" className="un-we-wtoolbar__ic" title="Redo" aria-label="Redo" onClick={() => dispatch(redo())}><RedoIcon /></button>
      <span className="un-we-wtoolbar__sep" />
      <button type="button" className="un-we-wtoolbar__ic" title="Zoom out" aria-label="Zoom out" onClick={onZoomOut}><MinusIcon /></button>
      <button type="button" className="un-we-wtoolbar__zoom" title="Reset zoom" onClick={onZoomReset}>{Math.round(zoom * 100)}%</button>
      <button type="button" className="un-we-wtoolbar__ic" title="Zoom in" aria-label="Zoom in" onClick={onZoomIn}><PlusIcon /></button>
      <span className="un-we-wtoolbar__sep" />
      <button
        type="button"
        className={`un-we-wtoolbar__ic${filmOpen ? ' on' : ''}`}
        title={filmOpen ? 'Hide steps panel' : 'Show steps panel'}
        aria-label={filmOpen ? 'Hide steps panel' : 'Show steps panel'}
        aria-pressed={filmOpen}
        onClick={onToggleFilm}
      ><PanelBottomIcon /></button>
      <button
        type="button"
        className={`un-we-wtoolbar__ic${inspOpen ? ' on' : ''}`}
        title={inspOpen ? 'Hide inspector panel' : 'Show inspector panel'}
        aria-label={inspOpen ? 'Hide inspector panel' : 'Show inspector panel'}
        aria-pressed={inspOpen}
        onClick={onToggleInsp}
      ><PanelRightIcon /></button>
    </div>
  );
};

export default WalkthroughCanvasToolbar;
